/* ==========================================================================
   PuraMadera — movimiento sutil sobre el tema Craft
   --------------------------------------------------------------------------
   Sin dependencias. No usa GSAP: para el movimiento sutil de todo el sitio
   basta IntersectionObserver + rAF, y así no cargamos 70 KB de librería en
   cada página. GSAP entra después, solo en la sección de vista explotada.

   Respeta prefers-reduced-motion: si el visitante pidió menos movimiento,
   este archivo no hace absolutamente nada.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.documentElement;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var supported = 'IntersectionObserver' in window;

  // Sin soporte o con movimiento reducido: no se marca .pm-js, así que el CSS
  // nunca esconde nada y la página se ve completa desde el primer frame.
  if (reduceMotion.matches || !supported) return;

  root.classList.add('pm-js');

  // Red de seguridad: si por lo que sea algo quedó oculto a los 3 s, se muestra.
  window.setTimeout(function () {
    document.querySelectorAll('[data-pm-reveal]:not(.pm-is-visible)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.5) el.classList.add('pm-is-visible');
    });
  }, 3000);

  /* ---------------------------------------------------------------------
     1. Entrada al viewport — fade-up escalonado
     Uso en Liquid:  <div data-pm-reveal>            elemento simple
                     <div data-pm-reveal="media">    imágenes (zoom-out)
                     <div data-pm-reveal-group>      escalona a sus hijos
     --------------------------------------------------------------------- */

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('pm-is-visible');
        revealObserver.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
  );

  function registerReveals(root) {
    (root || document).querySelectorAll('[data-pm-reveal]').forEach(function (el) {
      revealObserver.observe(el);
    });

    // Escalonado: cada hijo directo entra 90 ms después del anterior.
    (root || document).querySelectorAll('[data-pm-reveal-group]').forEach(function (group) {
      var step = parseInt(group.dataset.pmRevealStep, 10) || 90;
      Array.prototype.forEach.call(group.children, function (child, i) {
        if (!child.hasAttribute('data-pm-reveal')) {
          child.setAttribute('data-pm-reveal', '');
        }
        child.style.setProperty('--pm-reveal-delay', i * step + 'ms');
        revealObserver.observe(child);
      });
    });
  }

  /* ---------------------------------------------------------------------
     2. Parallax sutil en imágenes de ambiente
     Uso:  <img data-pm-parallax="0.12">   (0 = quieto, 0.3 = notorio)
     Un solo listener de scroll para toda la página, con rAF.
     --------------------------------------------------------------------- */

  var parallaxItems = [];
  var ticking = false;

  function registerParallax(root) {
    (root || document).querySelectorAll('[data-pm-parallax]').forEach(function (el) {
      var strength = parseFloat(el.dataset.pmParallax);
      if (isNaN(strength)) strength = 0.12;
      parallaxItems.push({ el: el, strength: Math.min(Math.max(strength, 0), 0.35) });
    });
  }

  function updateParallax() {
    var viewportH = window.innerHeight;

    parallaxItems.forEach(function (item) {
      var rect = item.el.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportH) return;

      // -1 cuando el elemento entra por abajo, +1 cuando sale por arriba.
      var progress = (rect.top + rect.height / 2 - viewportH / 2) / (viewportH / 2);
      var offset = progress * item.strength * 100;
      item.el.style.setProperty('--pm-parallax', offset.toFixed(2) + 'px');
    });

    ticking = false;
  }

  function onScroll() {
    if (ticking || parallaxItems.length === 0) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  }

  /* ---------------------------------------------------------------------
     3. Cabecera que se compacta al bajar
     --------------------------------------------------------------------- */

  // La referencia a la cabecera se cachea una sola vez. Antes se hacía un
  // querySelector en CADA evento de scroll nativo —decenas por segundo en un
  // Android de gama baja— mientras el resto del archivo evita justo eso.
  var headerEl = null;
  var lastY = window.scrollY;

  function onHeaderScroll() {
    // OJO: el selector era '.header-wrapper, .section-header'. querySelector
    // devuelve el PRIMERO en orden de documento, y la sección envuelve al
    // wrapper: la clase caía en la sección, no en .header-wrapper. Todo el CSS
    // de `.header-wrapper.pm-header--scrolled` nunca llegó a aplicarse —el
    // logotipo compacto, el cristal del estado fijo, el filo inferior.
    // Se pide el wrapper explícitamente y la sección solo como respaldo.
    if (!headerEl) {
      headerEl = document.querySelector('.header-wrapper') ||
                 document.querySelector('.section-header');
    }
    if (!headerEl) return;

    var y = window.scrollY;
    headerEl.classList.toggle('pm-header--scrolled', y > 40);
    lastY = y;
  }


  /* ---------------------------------------------------------------------
     4. Títulos con máscara
     El texto entra deslizándose desde detrás de su propio borde inferior.
     Necesita un envoltorio interno que el CSS pueda mover sin mover la caja,
     y lo pone el JS para no ensuciar el Liquid de cada sección.

     Uso en Liquid:  <h2 data-pm-reveal="mascara">Texto</h2>

     No parte el texto en líneas reales: partir por líneas exige medir y se
     rompe en cuanto cambia el ancho o la tipografía tarda en cargar. Un solo
     envoltorio da el 90 % del efecto con cero riesgo de reflow.
     --------------------------------------------------------------------- */

  function envolverMascaras(scope) {
    (scope || document)
      .querySelectorAll('[data-pm-reveal="mascara"]')
      .forEach(function (el) {
        if (el.querySelector('.pm-mascara__linea')) return;
        var linea = document.createElement('span');
        linea.className = 'pm-mascara__linea';
        while (el.firstChild) linea.appendChild(el.firstChild);
        el.appendChild(linea);
      });
  }

  /* ---------------------------------------------------------------------
     5. Cifras que cuentan al entrar
     Sobre .pm-datos__figura. Conserva todo lo que no sea dígito —el "+",
     el "%", el "años"— y respeta el punto de miles colombiano: "+1.400
     municipios" cuenta hasta 1.400 y vuelve a escribirse con su punto.

     Si la cifra no tiene número (por ejemplo "Hecho a mano"), no se toca.
     --------------------------------------------------------------------- */

  var SEPARADOR_MILES = /\B(?=(\d{3})+(?!\d))/g;

  function formatear(n) {
    return String(n).replace(SEPARADOR_MILES, '.');
  }

  function animarCifra(el) {
    var original = el.textContent.trim();
    var coincide = original.match(/^([^\d]*)([\d.,]+)(.*)$/);
    if (!coincide) return;

    var antes = coincide[1];
    var crudo = coincide[2];
    var despues = coincide[3];

    // Se quitan los puntos de miles antes de leer el número, pero se recuerda
    // si los tenía para volver a ponerlos al escribir.
    var teniaMiles = crudo.indexOf('.') !== -1 && !/\.\d{1,2}$/.test(crudo);
    var destino = parseInt(crudo.replace(/\./g, ''), 10);
    if (isNaN(destino) || destino <= 0) return;

    // Cifras muy pequeñas no ganan nada contando: 6 años cuenta 1,2,3… y se
    // lee como un error. Desde 10 hacia arriba sí.
    if (destino < 10) return;

    var duracion = 1400;
    var inicio = null;

    el.setAttribute('aria-label', original);
    el.setAttribute('role', 'text');

    function paso(ahora) {
      if (inicio === null) inicio = ahora;
      var t = Math.min((ahora - inicio) / duracion, 1);
      // Misma curva que el resto del sitio: arranca rápido, frena al final.
      var suave = 1 - Math.pow(1 - t, 3);
      var valor = Math.round(destino * suave);
      el.textContent = antes + (teniaMiles ? formatear(valor) : valor) + despues;
      if (t < 1) window.requestAnimationFrame(paso);
      else el.textContent = original;
    }

    window.requestAnimationFrame(paso);
  }

  var cifraObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animarCifra(entry.target);
        cifraObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.6 }
  );

  function registrarCifras(scope) {
    (scope || document).querySelectorAll('.pm-datos__figura').forEach(function (el) {
      cifraObserver.observe(el);
    });
  }


  /* ---------------------------------------------------------------------
     6. Vídeo del taller — solo se descarga y se reproduce si lo van a ver
     El <video> sale con preload="none": sin esto, 2 MB se descargan en toda
     visita a la ficha aunque nadie baje hasta ahí. Se pide la descarga al
     acercarse, se reproduce al entrar y se pausa al salir.
     --------------------------------------------------------------------- */

  // El navegador puede negarse a reproducir aunque el video este mudo: Chrome
  // pausa el video sin audio cuando la ventana no esta en primer plano ("video-only
  // background media was paused to save power"), y algunos moviles exigen que el
  // visitante haya tocado la pagina antes. En esos casos el video se queda en su
  // poster, que es un fallo correcto, y se reintenta cuando la pestana vuelve a
  // estar visible o al primer gesto del visitante.
  var videosEnEspera = [];

  function botonDe(v) {
    var marco = v.parentNode;
    return marco ? marco.querySelector('[data-pm-video-play]') : null;
  }

  // reproduciendo = true  -> el botón pausa
  // reproduciendo = false -> el botón reproduce
  function marcarBoton(v, reproduciendo) {
    var b = botonDe(v);
    if (!b) return;
    b.hidden = false;
    b.setAttribute('aria-pressed', reproduciendo ? 'true' : 'false');
    var etiqueta = b.querySelector('[data-pm-video-texto]');
    if (etiqueta) {
      etiqueta.textContent = reproduciendo
        ? 'Pausar el vídeo del taller'
        : 'Reproducir el vídeo del taller';
    }
  }

  function intentarReproducir(v) {
    var p = v.play();
    if (!p || !p.then) return;
    p.then(function () {
      // NO se esconde el botón. El vídeo va en bucle, y WCAG 2.2.2 exige poder
      // pararlo: si el botón desaparece al arrancar, no queda ningún control.
      // Pasa a ser botón de pausa.
      marcarBoton(v, true);
    }).catch(function () {
      marcarBoton(v, false);           // bloqueada: que se vea que hay que pulsar
      if (videosEnEspera.indexOf(v) === -1) videosEnEspera.push(v);
    });
  }

  // El botón es el respaldo, y también el control manual: un clic del visitante
  // siempre puede reproducir, porque cuenta como gesto para el navegador.
  document.addEventListener('click', function (ev) {
    var boton = ev.target.closest && ev.target.closest('[data-pm-video-play]');
    if (!boton) return;
    var v = boton.parentNode.querySelector('[data-pm-video-taller]');
    if (!v) return;
    if (!v.paused) { v.pause(); marcarBoton(v, false); return; }
    if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); }
    intentarReproducir(v);
  });

  function reintentarVideos() {
    var pendientes = videosEnEspera.slice();
    videosEnEspera.length = 0;
    pendientes.forEach(function (v) {
      var r = v.getBoundingClientRect();
      if (r.bottom > 0 && r.top < window.innerHeight) intentarReproducir(v);
    });
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) reintentarVideos();
  });
  ['pointerdown', 'keydown', 'touchstart'].forEach(function (evt) {
    window.addEventListener(evt, reintentarVideos, { once: true, passive: true });
  });

  var videoObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (v.preload !== 'auto') { v.preload = 'auto'; v.load(); }
          intentarReproducir(v);
        } else if (!v.paused) {
          v.pause();
          marcarBoton(v, false);
        }
      });
    },
    { rootMargin: '200px 0px', threshold: 0.25 }
  );

  function registrarVideos(scope) {
    (scope || document).querySelectorAll('[data-pm-video-taller]').forEach(function (v) {
      videoObserver.observe(v);
    });
  }


  /* ---------------------------------------------------------------------
     7. Botón de pausa de la cinta
     WCAG 2.2.2: cualquier movimiento de más de cinco segundos necesita un
     mecanismo para pararlo. El :hover no lo es —no existe en táctil ni con
     teclado—, así que el control es un botón de verdad.

     La preferencia se recuerda dentro de la misma visita: si alguien paró la
     cinta en la home, no se la vuelve a encontrar moviéndose al volver.
     sessionStorage puede lanzar excepción (ventana privada, cookies
     bloqueadas), así que todo va envuelto.
     --------------------------------------------------------------------- */

  var CLAVE_CINTA = 'pm-cinta-quieta';

  function leerPreferencia() {
    try { return window.sessionStorage.getItem(CLAVE_CINTA) === '1'; }
    catch (e) { return false; }
  }

  function guardarPreferencia(quieta) {
    try { window.sessionStorage.setItem(CLAVE_CINTA, quieta ? '1' : '0'); }
    catch (e) { /* sin almacenamiento: la preferencia dura lo que la página */ }
  }

  function pintarCinta(cinta, quieta) {
    cinta.classList.toggle('pm-marquee--quieta', quieta);
    var boton = cinta.querySelector('[data-pm-marquee-pausa]');
    if (!boton) return;
    boton.setAttribute('aria-pressed', quieta ? 'true' : 'false');
    var etiqueta = boton.querySelector('[data-pm-marquee-texto]');
    if (etiqueta) {
      etiqueta.textContent = quieta
        ? 'Reanudar el texto en movimiento'
        : 'Detener el texto en movimiento';
    }
  }

  function registrarCintas(scope) {
    var quieta = leerPreferencia();
    (scope || document).querySelectorAll('.pm-marquee').forEach(function (cinta) {
      if (cinta.dataset.pmCintaLista === '1') return;
      cinta.dataset.pmCintaLista = '1';
      pintarCinta(cinta, quieta);
    });
  }

  document.addEventListener('click', function (ev) {
    var boton = ev.target.closest && ev.target.closest('[data-pm-marquee-pausa]');
    if (!boton) return;
    var cinta = boton.closest('.pm-marquee');
    if (!cinta) return;
    var quieta = !cinta.classList.contains('pm-marquee--quieta');
    pintarCinta(cinta, quieta);
    guardarPreferencia(quieta);
  });

  /* ---------------------------------------------------------------------
     Arranque
     --------------------------------------------------------------------- */

  /* ---------------------------------------------------------------------
     El rótulo de un apartado con hijos navega; la flecha despliega
     ---------------------------------------------------------------------
     Craft monta los apartados con submenú como <details><summary>, y un
     <summary> no es un enlace: por eso "Catálogo" no llevaba a ninguna parte
     y hubo que colgarle un hijo "Ver todo". Los snippets del menú ahora meten
     el rótulo dentro de un <a> (ver el parche en header-dropdown-menu.liquid).

     Falta impedir que ese clic haga las dos cosas a la vez: el navegador
     alterna el <details> cuando se pulsa cualquier descendiente del summary.
     preventDefault sobre el evento del summary corta la apertura sin tocar la
     navegación del enlace.
     --------------------------------------------------------------------- */
  function enlazarPadresDeMenu(raiz) {
    (raiz || document).querySelectorAll('[data-pm-menu-padre]').forEach(function (a) {
      if (a.dataset.pmLigado) return;
      a.dataset.pmLigado = '1';
      a.addEventListener('click', function (e) {
        e.stopPropagation();
        var resumen = a.closest('summary');
        if (!resumen) return;
        // Un solo oyente de usar y tirar: corta ESTE toggle, no los futuros.
        resumen.addEventListener('click', function corta(ev) {
          ev.preventDefault();
          resumen.removeEventListener('click', corta, true);
        }, true);
      });
      // Con teclado, Enter sobre el enlace navega; el summary sigue abriendo
      // con su propio foco, así que la pauta de divulgación no se rompe.
      a.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
      });
    });
  }

  function init() {
    enlazarPadresDeMenu(document);
    envolverMascaras(document);
    registerReveals(document);
    registrarCifras(document);
    registrarVideos(document);
    registrarCintas(document);
    registerParallax(document);
    updateParallax();
    onHeaderScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Un único rAF para todo lo que reacciona al scroll. La cabecera iba suelta,
  // fuera del throttle que ya protegía al parallax.
  var scrollPendiente = false;

  window.addEventListener('scroll', function () {
    if (scrollPendiente) return;
    scrollPendiente = true;
    window.requestAnimationFrame(function () {
      scrollPendiente = false;
      updateParallax();
      onHeaderScroll();
    });
  }, { passive: true });

  window.addEventListener('resize', onScroll, { passive: true });

  // El editor de temas recarga secciones sin recargar la página:
  // hay que volver a registrar lo que se acaba de inyectar.
  document.addEventListener('shopify:section:load', function (event) {
    enlazarPadresDeMenu(event.target);
    envolverMascaras(event.target);
    registerReveals(event.target);
    registrarCifras(event.target);
    registrarVideos(event.target);
    registrarCintas(event.target);
    parallaxItems = [];
    registerParallax(document);
    updateParallax();
  });
})();

